var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSignOutArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.114,
    height: 6.073,
    viewBox: "0 0 12.114 6.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.94-2.242-.232-4.95a.328.328,0,0,0,0-.464L-2.94-8.122a.328.328,0,0,0-.56.232v1.942h-8.422a.328.328,0,0,0-.328.328v.875a.328.328,0,0,0,.328.328H-3.5v1.942A.328.328,0,0,0-2.94-2.242Z",
    transform: "translate(12.25 8.219)",
    fill: "#3a3630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSignOutArrow);
export default __webpack_public_path__ + "static/media/icons_SignOutArrow.6adb4b521e347bd4b36f401e529d0785.svg";
export { ForwardRef as ReactComponent };